import {unitsModule} from "./unitsModule";

class UnitsController {

    constructor() {
    }

}


unitsModule.controller("unitsController", UnitsController)